// All user-visible strings (Thai). Only the about block's lang="en" paragraph in index.html is
// English. Every control reads its label/copy from here — never a hardcoded Thai literal in main.js.
import { FITS, DEPTH, SNAP, snapOverlap, fmt } from '../doc.js';
const S = {
  title: "แก้วกาแฟใส่โลโก้",
  gLogo: "โลโก้บนแก้ว",
  gSize: "ขนาดแก้ว",
  gColour: "สี",
  gLid: "ฝาและการพิมพ์",
  loadingFont: (family, got, total) => (total > 0 ? `กำลังโหลด ${family} ${got.toFixed(1)} / ${total.toFixed(1)} MB` : `กำลังโหลด ${family} ${got.toFixed(1)} MB`),
  needFile: "เลือกไฟล์ SVG ของโลโก้ — ไฟล์อยู่ในเครื่องของคุณ ไม่ถูกส่งไปที่ใด",
  artKept: "โลโก้อยู่ในหน้านี้เท่านั้น — รีเฟรชหน้าแล้วต้องเลือกไฟล์ใหม่",
  keptOld: "(ยังใช้โลโก้เดิมอยู่)",
  thumb: "ตัวอย่างโลโก้ที่อ่านได้",
  mode: "แบบโลโก้",
  modes: {
    flush: "เรียบ",
    raised: "นูน",
    engraved: "เซาะร่อง",
  },
  styleLabel: "ทรงแก้ว",
  styles: {
    classic: "ทรงคลาสสิก",
    thin: "ผนังบางเหมือนจริง",
  },
  modeNote: (style, mode) => {
    if (mode === 'raised') return `นูนออกมา ${fmt(DEPTH[style].raised[1])} มม. — ใช้ได้ทั้งเครื่องพิมพ์หลายสีและสีเดียว (สีเดียวจะเห็นเป็นลายนูน)`;
    if (mode === 'engraved') return `เซาะร่องลึก ${fmt(DEPTH[style].engraved[0])} มม. ไม่มีชิ้นโลโก้แยก — เหมาะกับเครื่องพิมพ์สีเดียว`;
    const flush = 'เรียบเสมอผิวแก้ว — สำหรับเครื่องพิมพ์หลายสี (พิมพ์สีเดียวจะมองไม่เห็นโลโก้)';
    return style === 'thin' ? `${flush} ผนังบาง: โลโก้หนา ${fmt(DEPTH.thin.flush[0])} มม. สีอ่อนบนแก้วสีเข้มอาจดูหม่น ถ้าต้องการสีชัดให้เลือกแบบนูน` : flush;
  },
  scale: "ขนาดโลโก้",
  pos: "เลื่อนขึ้น–ลง",
  hideThin: "ซ่อนชิ้นที่บางเกินพิมพ์",
  signedPercent: (v) => `${v > 0 ? '+' : ''}${Math.round(v * 100)}%`,
  size: "ขนาด",
  presets: {
    mini: "มินิ",
    s: "S",
    m: "M",
    l: "L",
  },
  d: "กว้าง (มม.)",
  adjusted: (v, lo, hi) => `ปรับเป็น ${v} มม. (ช่วงที่ทำได้ ${lo}–${hi} มม.)`,
  looks: "ชุดสี",
  lookNames: {
    mono: "ดำ-ขาว",
    kraft: "คราฟต์",
    white: "ขาว",
  },
  parts: {
    body: "แก้ว",
    ring: "วงแหวน",
    logo: "โลโก้",
  },
  colour: {
    body: "สีตัวแก้ว",
    lid: "สีฝา",
    ring: "สีวงแหวน",
    logo: "สีโลโก้",
  },
  lidOn: "ทำฝา",
  ringOn: "วงแหวน",
  fit: "ความแน่นของฝา",
  fits: {
    tight: "แน่นมาก",
    snug: "พอดี",
    normal: "หลวมเล็กน้อย",
    loose: "หลวม",
  },
  fitNote: (style, fit, d) => {
    if (style !== 'thin') return `เผื่อช่องว่าง ${fmt(FITS[fit])} มม. ต่อด้าน — ฝาสวมด้วยแรงเสียดทาน ไม่มีตัวล็อก`;
    if (fit === 'loose') return `ฝาสวมหลวม ไม่ล็อก — เผื่อช่องว่าง ${fmt(SNAP.loose.c)} มม. ต่อด้าน`;
    return `ฝาล็อกใต้ขอบแก้ว — ขอบล็อกซ้อนขอบแก้ว ${snapOverlap(SNAP[fit], d).toFixed(2)} มม.`;
  },
  partLabel: "ไฟล์ที่ดาวน์โหลด",
  partNames: {
    set: "ชุด",
    cup: "แก้ว",
    lid: "ฝา",
  },
  lift: "ยกฝา",
  outer: (d, h) => `ø ${d} × ${h} มม.`,
  footprint: (w, d) => `พิมพ์ ${w} × ${d} มม.`,
  capacity: (ml) => `จุ ${ml} มล.`,
  problem: {
    "thin-text": "ตัวอักษรบางมาก — บางเส้นอาจพิมพ์ไม่ติด ลองเพิ่มขนาดแก้วหรือลดจำนวนตัวอักษร",
    "thin-parts": "โลโก้มีเส้นบางที่ติดกับส่วนหนา — สไลเซอร์อาจตัดทิ้ง",
    dropped: (p) => `ตัดชิ้นที่บางเกินพิมพ์ออกจากโลโก้ ${p.n} ชิ้น`,
    "all-thin": "โลโก้บางเกินไปสำหรับขนาดแก้วนี้ — ดาวน์โหลดไม่ได้",
    "art-too-complex": "โลโก้ซับซ้อนเกินไป — ดาวน์โหลดไม่ได้",
  },
  hairline: "ข้อจำกัด: เส้นบางมากที่ติดอยู่กับส่วนหนาของโลโก้จะตรวจไม่พบ และสไลเซอร์อาจตัดทิ้ง — ดูตัวอย่างในสไลเซอร์ก่อนพิมพ์",
  dlstl: "STL",
  copied: "คัดลอกแล้ว",
  fatal: "โหลดตัวคำนวณไม่สำเร็จ — ลองรีเฟรชหน้า",
  buildTimeout: (src) => (src === 'svg' ? 'สร้างแบบไม่เสร็จใน 10 วินาที จึงเริ่มใหม่ — ลองใช้ไฟล์ที่เรียบง่ายกว่า' : 'สร้างแบบไม่เสร็จใน 10 วินาที จึงเริ่มใหม่ — ลองลดตัวอักษรหรือเปลี่ยนฟอนต์'),

  // ship 3 piece c: the template's static text, baked per language by the build (was hardcoded Thai)
  aboutP: "ออกแบบแก้วกาแฟจิ๋วพร้อมฝา ใส่ชื่อหรือโลโก้ร้านบนตัวแก้ว เลือกขนาด สี และความแน่นของฝา ดาวน์โหลดไฟล์ 3MF/STL ใช้ฟรี เป็นโมเดลตกแต่ง ไม่ใช่ภาชนะใส่เครื่องดื่ม",
};
export default S;
